import React from "react";
import { theme } from "src/config";
import styled, { css } from "styled-components";
import { Icon } from "../icon";
import { LanguageMenu } from "../languageMenu";


export const LanguageSelect = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [showLanguageMenu, setShowLanguageMenu] = React.useState<boolean>(false);

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef?.current && !containerRef.current.contains(event.target as Node)) {
      setShowLanguageMenu(false);
    }
  };

  return(
    <LanguageMenuContainer ref={containerRef}>
        <Icon
          onClick = {() => setShowLanguageMenu(!showLanguageMenu)}
          iconId  = "translate"
          color   = "white"
          size    = "large"
        />
        {showLanguageMenu && (
          <LanguageMenu onClick={() => setShowLanguageMenu(false)} />
        )}
      </LanguageMenuContainer>
  );
}

const LanguageMenuContainer = styled.div<{
  showSidebar?: boolean;
  hide?:        boolean;
}>`
  cursor:          pointer;
  display:         flex;
  justify-content: flex-start;
  align-items:     center;
  font-size:       ${theme.font.size.small};
  ${(props) => props.hide
      ? css`
          padding: 0rem 0.5rem 0.75rem 1.75rem;
        `
      : css`
          padding: 0.75rem 0.5rem 0.75rem 1.75rem;
        `
  };
`;